import * as React from 'react'
import { CallRegular } from '@fluentui/react-icons'
import { Button } from '@fluentui/react-components'

type PhoneNumberButtonProps = {
    phoneNumber: string
}

export default function PhoneNumberButton(props: PhoneNumberButtonProps) {
    return (
        <Button
            size="small"
            appearance={'subtle'}
            icon={<CallRegular />}
            onClick={e => {
                e.stopPropagation()
                window.open(`tel:${props.phoneNumber}`)
            }}
        >
            {props.phoneNumber}
        </Button>
    )
}
